import { Theme } from '@material-ui/core';

export const MuiToggleButtonGroup = (theme: Theme): Record<string, unknown> => ({
  root: {
    boxShadow: '0 3px 8px -3px #00000033',
  },
});
